import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getShopInfo } from '@conversion/selectors';
import getPreferredDishes from '@shopDetails/selectors/getPreferredDishes';

const mapStateToProps = createStructuredSelector({
  shop: getShopInfo,
  section: getPreferredDishes,
});

export default connect(mapStateToProps, null);
